var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',[_c('v-chart',{staticStyle:{"width":"250px","height":"183px"},attrs:{"option":_vm.chartOptions}})],1),_c('div',{staticStyle:{"text-align":"center"}},[_c('div',{style:({
        display: 'inline-block',
        fontWeight: '600',
        marginTop: '-15px',
        color: _vm.titleColor
      })},[_vm._v(" Realizado: ")]),_c('div',{style:({
        marginLeft: '4px',
        display: 'inline-block',
        fontWeight: '600',
        color: _vm.valueColor
      })},[_vm._v(" "+_vm._s(_vm.formattedValue)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }